import { IssuePriority } from './issues';

/**
 * Bootstrap color variants for issue priority badges
 */
export const issuePriorityColors: Record<IssuePriority, string> = {
    [IssuePriority.HIGH]: 'danger',
    [IssuePriority.MEDIUM]: 'warning',
    [IssuePriority.LOW]: 'secondary'
};

/**
 * Swedish labels for issue priorities
 */
export const issuePriorityLabels: Record<IssuePriority, string> = {
    [IssuePriority.HIGH]: 'Hög',
    [IssuePriority.MEDIUM]: 'Medium',
    [IssuePriority.LOW]: 'Låg'
};
